import React from 'react'
import {
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
} from '@chakra-ui/react'
import styles from './Select.module.scss'
import classNames from 'classnames'
import { ErrorMessage, Field } from 'formik'
import { FlexColumn } from '../Containers'

interface SelectProps extends ChakraSelectProps {
  wrapperClassName?: string
  name?: string
  isFormik?: boolean
  options: {
    label: string
    value: string
  }[]
}

const Select: React.FC<SelectProps> = ({
  wrapperClassName,
  options,
  placeholder,
  isFormik = false,
  name,
  ...props
}) => {
  return (
    <div className={classNames(styles.select, wrapperClassName)}>
      {isFormik ? (
        <FlexColumn gap="5px" align='flex-start'>
          <Field name={name}>
            {({ field, form }: any) => (
              <ChakraSelect
                {...props}
                {...field}
                className={classNames(form.errors[name] && styles.error)}
              >
                {placeholder && (
                  <option selected hidden disabled value="">
                    {placeholder}
                  </option>
                )}
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </ChakraSelect>
            )}
          </Field>
          <ErrorMessage
            className={classNames('error')}
            name={name}
            component="span"
          />
        </FlexColumn>
      ) : (
        <>
          <ChakraSelect {...props}>
            {placeholder && (
              <option selected hidden disabled value="">
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </ChakraSelect>
        </>
      )}
    </div>
  )
}

export default Select
